import {
  Button,
  CloseButton,
  Grid,
  Heading,
  Modal,
  TextInput,
} from "@instructure/ui";
import { t } from "i18next";
import React, { useState } from "react";
import { CycleTypeService } from "../../services/CyclesService";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";

export const CycleTypeEditModal = ({
  open,
  cycleType,
  onCloseHandler,
  setLoad,
  reloadData,
}) => {
  const showNotification = useNotification();
  const [newCycleType, setNewCycleType] = useState({ ...cycleType });

  const handleClose = () => {
    open = false;
    onCloseHandler(null);
  };

  const handleSubmit = () => {
    setLoad(true);
    const promise = newCycleType.id
      ? CycleTypeService.updateCycleType(newCycleType)
      : CycleTypeService.createCycleType(newCycleType);
    promise
      .then(() => {
        setLoad(false);
        handleClose(true);
        reloadData(true);
        open = false;
        onCloseHandler(newCycleType);
        showNotification(t("notifications.cycle.createCycleTypeSuccess"));
      })
      .catch((e) => {
        showNotification(
          `${t("notifications.cycle.createCycleTypeError")} ${e}`,
          ERROR
        );
      });
  };

  const getModalHeader = () => (
    <Modal.Header>
      <Grid hAlign="space-between">
        <Grid.Row>
          <Grid.Col>
            <Heading level="h2" as="h1">
              {t("cyclesAndGoals.cycleType.newCycleType")}
            </Heading>
          </Grid.Col>
          <Grid.Col width="auto">
            <CloseButton
              size="small"
              screenReaderLabel={t("global.close")}
              onClick={handleClose}
            />
          </Grid.Col>
        </Grid.Row>
      </Grid>
    </Modal.Header>
  );

  const getModalBody = () => {
    return (
      <Grid colSpacing="small" rowSpacing="small" vAlign="middle">
        <Grid.Row key={"edited-assignment-row"}>
          <Grid.Col width={4}>
            <TextInput
              value={newCycleType.name ? newCycleType.name : ""}
              interaction={"enabled"}
              id={"cycle-type-name"}
              renderLabel={t("cyclesAndGoals.cycleType.cycleTypeName")}
              onChange={(e) => {
                newCycleType.name = e.currentTarget.value;
                setNewCycleType({ ...newCycleType });
              }}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <TextInput
              value={newCycleType.duration ? newCycleType.duration : ""}
              interaction={"enabled"}
              id={"cycle-type-duration"}
              renderLabel={t("cyclesAndGoals.cycleType.cycleTypeDuration")}
              onChange={(e) => {
                newCycleType.duration = e.currentTarget.value;
                setNewCycleType({ ...newCycleType });
              }}
            />
          </Grid.Col>
        </Grid.Row>
      </Grid>
    );
  };

  const getModalFooter = () => (
    <Modal.Footer>
      <Button margin="0 small 0 0" onClick={handleClose}>
        {t("global.cancel")}
      </Button>

      <Button color="primary" type="submit" onClick={handleSubmit}>
        {t("global.submit")}
      </Button>
    </Modal.Footer>
  );

  return (
    <Modal
      key={"cycle-type-edit-modal"}
      open={open}
      onDismiss={handleClose}
      size="large"
      label={t("cyclesAndGoals.cycleType.newCycleType")}
      shouldCloseOnDocumentClick
    >
      {getModalHeader()}
      <Modal.Body>{getModalBody()}</Modal.Body>
      {getModalFooter()}
    </Modal>
  );
};
